<template>
	<vs-simple-upload
		:show-upload-button="false"
		:text="text"
		@change="changeLogo"
		class="site-logo-upload"
	/>
</template>

<script>
export default {
	name: "LogoUpload",
	props: {
		text: {
			type: String,
		}
	},
	methods: {
		changeLogo(err, files) {
			this.$emit("change", err, files);
		}
	}
};
</script>

<style lang="scss">
.site-logo-upload {
	height: 100%;

	.con-img-upload,
	.con-input-upload {
		margin: 0;
		padding: 0;
		width: 100%;
		height: 100%;
	}
}
</style>
